import { createI18n } from 'vue-i18n';

import { LocaleLanguage } from '@/enums/LocaleLanguage';
import en from '@/i18n/languages/en.json';
import ja from '@/i18n/languages/ja.json';
import ko from '@/i18n/languages/ko.json';
import vi from '@/i18n/languages/vi.json';
import zh from '@/i18n/languages/zh.json';

export default createI18n({
  locale: LocaleLanguage.Ko,
  fallbackLocale: LocaleLanguage.Ko,
  legacy: false,
  messages: {
    ko,
    en,
    ja,
    zh,
    vi,
  },
});
